import { Stack, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { useMemo } from "react";
import { useAllMatches } from "../../hooks";
import { formatPercentage } from "../../libs/gameAnalysis/utils";
import { MatchFilter } from "../../libs/statsFilters";
import { GlobalStatsSelection } from "../../types/stats";
import { getPlayersCount } from "../../utils/matches";

export type CityEscapePlayersNoDistributionProps = {
  selection?: GlobalStatsSelection & { enigmaId?: string };
  pending?: boolean;
  filters?: MatchFilter;
};

export function CityEscapePlayersNoDistribution({
  selection,
  pending,
  filters,
}: CityEscapePlayersNoDistributionProps) {
  // const matchHints = useMatchHints(cityEscapeId, undefined, filters);
  const allMatches = useAllMatches(
    { selection, filters },
    { enabled: !pending }
  );
  const totalPlayersNo = useMemo(() => {
    if (allMatches.data && Array.isArray(allMatches.data)) {
      let total = 0;
      for (const match of allMatches.data) {
        total += getPlayersCount(match) || 1;
      }
      return total;
    }
    return 0;
  }, [allMatches.data]);

  const playersDistribution = useMemo(() => {
    const distribution: Record<string, number> = {};
    if (allMatches.data && Array.isArray(allMatches.data)) {
      allMatches.data.forEach?.((match) => {
        const playersNo = getPlayersCount(match) || 1;
        distribution[playersNo] = (distribution[playersNo] || 0) + 1;
      });
    }
    return distribution;
  }, [allMatches.data]);

  return (
    <Stack direction="column" flexGrow={1}>
      <Typography variant="caption" gutterBottom>
        Numero di giocatori per partita
      </Typography>
      <PieChart
        loading={pending}
        series={[
          {
            data: Object.entries(playersDistribution).map(
              ([playersNo, count], i, array) => {
                // console.debug("Hints per match:", key, value);
                return {
                  id: playersNo,
                  value: count,
                  label: `${playersNo} Giocatori`,
                };
              }
            ),
            innerRadius: 30,
            outerRadius: 100,
            paddingAngle: 5,
            cornerRadius: 5,
            valueFormatter: (item: any) =>
              `${formatPercentage(item.value, totalPlayersNo)}`,
          },
        ]}
        width={200}
        height={200}
      />
    </Stack>
  );
}
